module.exports = __webpack_public_path__ + "static/media/ill_allergi.3601fd2b.svg";